import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Route, Router } from '@angular/router';

@Component({
  selector: 'app-error-message',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css', '../../../../../assets/css/new-buttons-theme.css']
})
export class ErrorMessageComponent implements OnInit {

  @Input() title: string = "";
  @Input() description: string = "";
  @Input() textButton: string = "";
  @Output() errorButton= new EventEmitter<void>();

  constructor() { }

  ngOnInit() {
  }

  public reload(): void {
    this.errorButton.emit();
  }

}
